export default __webpack_public_path__ + "fonts/icomoon.803535cccfff79daf24792e6d287f550.svg";